export default __webpack_public_path__ + "static/media/pic4.a32a643c.jpg";